import { useMemo } from 'react';
import { getDryRunLogisticsMetrics, getLogisticsMetrics } from '@lp/features/RoutePlanner/utils';
import { useRouteDetails } from '@lp/features/RoutePlanner/hooks/useRouteDetails';
import { RouteTypeEnum } from '@/api/apis/route';
import { useBaseCaseDetails } from '@/hooks/useBaseCaseDetails';
import { TimeMetricsItem } from './TimeMetricsItem';

export const LogisticsTimeMetrics = () => {
  const { legs: mainLegs } = useRouteDetails(RouteTypeEnum.Main);
  const { legs: dryRunLegs } = useRouteDetails(RouteTypeEnum.DryRun);
  const { donorHospitalDetails } = useBaseCaseDetails();

  const mainRouteMetrics = useMemo(() => {
    return getLogisticsMetrics(mainLegs);
  }, [mainLegs]);

  const dryRunRouteMetrics = useMemo(() => {
    return getDryRunLogisticsMetrics(mainLegs, dryRunLegs, donorHospitalDetails?.id);
  }, [mainLegs, dryRunLegs, donorHospitalDetails?.id]);

  return (
    <div className="flex gap-2 mt-2">
      <TimeMetricsItem type={RouteTypeEnum.Main} metricsList={mainRouteMetrics} />
      <TimeMetricsItem type={RouteTypeEnum.DryRun} metricsList={dryRunRouteMetrics} />
    </div>
  );
};
